const SearchInput = ({
  placeholder = "Search...",
  width = "w-[320px]",
  value,
  onChange,
}) => {
  return (
    <div
      className={`${width} h-[35px] rounded-[12px] bg-white shadow-[4px_4px_20px_0px_#00000040] flex items-center px-4`}
    >
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className="w-full h-[12px] bg-transparent text-[12px] font-inter font-normal text-[#00000096] 
        placeholder:text-[10px] placeholder:text-[#00000096] outline-none text-opacity-40"
      />
    </div>
  );
};

export default SearchInput;
